import { Button } from '../styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import { IconSvg } from '@/components/feature/UserPermissionPage/TabPermissionManagement/styles'
import Modal from '@/components/common/Modal'
import { ModalContent, ModalTitle } from './styles'
import { DeleteClaimButtonHook } from './DeleteClaimButton.hook'

function DeleteClaimButton() {
  const {
    isOpenConfirmDeleteCase,
    isBackofficeChannel,
    handleToggleConfirmDelete,
    handleFetchDeleteClaim,
  } = DeleteClaimButtonHook()

  return (
    isBackofficeChannel && (
      <>
        <Button onClick={handleToggleConfirmDelete}>
          <IconSvg src={IMAGE_URL.deleteIcon} /> ลบเคส
        </Button>
        <Modal
          open={isOpenConfirmDeleteCase}
          closable={false}
          width={350}
          footer={[
            <Button onClick={handleToggleConfirmDelete}>ยกเลิก</Button>,
            <Button type="primary" onClick={handleFetchDeleteClaim}>
              ยืนยัน
            </Button>,
          ]}
        >
          <ModalTitle>คุณต้องการลบรายการยื่นเคลม</ModalTitle>
          <ModalContent>หากลบจะต้องทำรายการใหม่ทั้งหมด</ModalContent>
        </Modal>
      </>
    )
  )
}

export default DeleteClaimButton
